import { IntercomWidgetVariant } from "../const";
import { KeypadButton } from "./KeypadButton";
// eslint-disable-next-line import/order
import { PropsWithChildren, createContext, useContext, useMemo } from "react";
import { cn } from "@/core/helpers/cn";

const KeypadContext = createContext<{
  variant: IntercomWidgetVariant;
  onButtonClick: (symbol: string) => void;
}>(null);

export function Keypad({
  children,
  variant,
  className,
  onButtonClick,
}: PropsWithChildren<{
  variant: IntercomWidgetVariant;
  className?: string;
  onButtonClick: (symbol: string) => void;
}>) {
  const contextValue = useMemo(() => ({ variant, onButtonClick }), [variant, onButtonClick]);

  return (
    <KeypadContext.Provider value={contextValue}>
      <div className={cn(`flex flex-col gap-[6px]`, className)}>{children}</div>
    </KeypadContext.Provider>
  );
}

function KeypadRow({ children }: PropsWithChildren) {
  return <div className="flex justify-between">{children}</div>;
}

type KeypadButtonProps = {
  symbol: string;
};

function Button({ symbol }: KeypadButtonProps) {
  const context = useContext(KeypadContext);

  if (!context) {
    throw new Error("Keypad.Button must be used within a Keypad component");
  }

  const { variant, onButtonClick } = context;

  return (
    <KeypadButton variant={variant} onClick={() => onButtonClick(symbol)}>
      {symbol}
    </KeypadButton>
  );
}

Keypad.Row = KeypadRow;
Keypad.Button = Button;
